export default {
    setMenuAreaClienteSelect(state, item) {
        state.menuAreaClienteSelect = item;
    },

    setLoadingAction(state, item) {
        state.loadingAction = item;
    },
}
